"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newId = void 0;
const uuid_1 = require("uuid");
const newId = () => (0, uuid_1.v4)();
exports.newId = newId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvSWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsK0JBQTBCO0FBR25CLE1BQU0sS0FBSyxHQUFHLEdBQU8sRUFBRSxDQUFDLElBQUEsU0FBRSxHQUFRLENBQUM7QUFBN0IsUUFBQSxLQUFLLFNBQXdCIn0=